/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import { ALIGN, defaultPrimitive, ILandingPrimitive, ILandingSection, ImageContent, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import "../../../assets/css/Image.scss"
import { ImagePrimitive } from "../primitive"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface IImageProps {
    section: ILandingSection
    data: ImageContent 
}
const Image = ({ section, ...props}: IImageProps): JSX.Element => {
    const data: ImageContent = props.data as ImageContent 
    const thumbRef        = useRef<HTMLDivElement>(null)
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width, setWidth] = useState<string>(
        getCssDemention( 
            data.width || data.position?.width,  
            getCssDemention( section.width, "100%") 
        )
    )
    const [height, setHeight] = useState<string>(
        getCssDemention( 
            data.height || data.position?.height,   
            "100%" 
        )
    )  
    const [thumbnailSize, setThumbnailSize] = useState<IScreenPosition>( data.position || { width: "100%", height: "100%" } )

    useEffect(() => {
            setTimeout(() => {
                if(thumbRef.current) {
                    const thumb = thumbRef.current! 
                    const w = thumb.clientWidth  || data.width  || data.position?.width || 101
                    const h = thumb.clientHeight || data.height || data.position?.height|| 101
                    setHeight( getCssDemention(data.height || data.position?.height || thumb.clientHeight))
                    setWidth(  getCssDemention( data.width || data.position?.width  || thumb.clientWidth ))
                    setThumbnailSize({
                        width:  w,
                        height: h, 
                        aspect: parseInt(w.toString()) / parseInt(h.toString())
                    })
                }
            }, 100)
    }, [ data.position ])

    useEffect(() => {
        addCSSClass(
            `landing-image-cont-${props.data.id}`,
            `.landing-image-cont-${props.data.id} {
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            }`
        )       
        return () => {
            removeCSSClass(`landing-image-cont-${props.data.id}`)
        }
    }, [])
    
    //console.log( data )
    
    const primitive: ILandingPrimitive = {
        ...defaultPrimitive(), 
        id:  data.id ||section.id,
        data,
        border: data.border,
        hover_size: data.hover_size,
        style: {...data.style},
        position: thumbnailSize
    } 
    
    return <div 
        className={`landing-content-container landing-image landing-image-cont-${props.data.id} ${ data.className || "" } `}   
        data-type={data.type} 
        data-content-id={data.id} 
        ref={thumbRef}
    >
        {
            !!data.src
                ?
                thumbnailSize.width !== "100%" && 
                    <>
                        <ImagePrimitive
                            primitive={ primitive }  
                            {
                                ...{ "data-content-id": props.data.id }
                            }
                        />
                        <DataContentEditor data={data} section={section} />
                    </> 
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} landing-image-${data.id} `
                        },
                    }, 
                    ...props 
                }} />
        }
    </div>
}
export default Image
 